import * as tslib_1 from "tslib";
import { Validators } from '@angular/forms';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { EControls } from '../../enums/controls.enum';
import { whiteSpaceValidator } from 'src/app/shared/validators';
var FormValidators = /** @class */ (function () {
    function FormValidators() {
        this.idValidator = function (fc) {
            return /^[a-zA-Z0-9]{5,20}$/.test(fc.value) ? null : { documentIdPatternError: true };
        };
        this.passportValidator = function (fc) {
            return /^[a-zA-Z0-9]{5,14}$/.test(fc.value) ? null : { documentPassportPatternError: true };
        };
        this.spanishIdValidator = function (fc) {
            var _a = fc.value, value = _a === void 0 ? '' : _a;
            var match = value.trim().match(new RegExp('^([xyzZYX])?([0-9]{7,8})([a-zA-Z])$'));
            if (match) {
                var _ = match[0], _b = match[1], prefix = _b === void 0 ? '0' : _b, n = match[2], _c = match[3], letter = _c === void 0 ? '' : _c;
                var pre = prefix.replace('X', '0').replace('Y', '1').replace('Z', '2');
                var index = Number("" + pre + n) % 23;
                if ('TRWAGMYFPDXBNJZSQVHLCKET'[index] === letter.toUpperCase()) {
                    return null;
                }
            }
            return { documentIdPatternError: true };
        };
        this.countryCode = InjectorService.get().get(ConfigService).booking.acc.country.code;
    }
    FormValidators.prototype.get = function (control) {
        var validators = control.required ? [
            Validators.required
        ].concat((control.type === 'TEXT' || control.type === 'AUTOSUGGEST') ? [whiteSpaceValidator] : []) : [];
        switch (control.id) {
            case EControls.clientEmail:
                return { validators: validators.concat([Validators.email]) };
            case EControls.clientName:
            case EControls.clientFirstSurname:
            case EControls.clientSecondSurname:
                if (this.countryCode === 'ES') {
                    validators.push(Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚçÇñÑ ]*'));
                }
                return tslib_1.__assign({ validators: validators }, (this.countryCode === 'ES') && { pattern: '[^a-zA-ZáéíóúÁÉÍÓÚçÇñÑ ]' });
            default:
                return { validators: validators };
        }
    };
    return FormValidators;
}());
export { FormValidators };
